import { atom } from "jotai";
import { fetchUserIndex } from "@Services/api";
import { IApiUserIndex } from '@Types/api';

type TLoginInfo = null | undefined | IApiUserIndex;

/** 消息原子 */
export const initLoginAtom = atom<TLoginInfo | undefined>(null);

/** 使用方法
 * :const [loginInfo,updateLoginInfo]=useAtom(loginAtom)
 * 直接调用updateLoginInfo即可
 *  */
export const loginAtom = atom(
  (_get) => _get(initLoginAtom),
  async (_get, _set, params = {} as any) => {
    const res = await fetchUserIndex(params);
    
    const data = !!res?.data?.m_id ? res : undefined;

    _set(initLoginAtom, data);
  },
);
